import { useEffect } from 'react';
import useStore from '@/stores/useStore';

export function useAuthErrorFromUrl() {
  const setSnackbar = useStore((state) => state.setSnackbarState);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('error') === 'access_denied') {
      setSnackbar({
        open: true,
        severity: 'error',
        message: params.get('error_description') || 'Access denied',
      });
    }
  }, [setSnackbar]);
}
